import React from 'react';
import underline from '../assets/images/underline-grey.png';

import NewsletterSubmitMessage from '../components/newsletter-submit-message';

import './newsletter.scss';

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};

export default class Newsletter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      submitted: false,
      submitResponse: '',
      submitResponseIsVisible: false
    };

    this.resetSubmitMessage = this.resetSubmitMessage.bind(this);
  }

  /* Here’s the juicy bit for posting the form submission */
  handleSubmit = e => {
    e.preventDefault();

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!re.test(this.state.email)) {
      this.setState({
        submitResponse: 'Hm, that doesn’t look like a valid e-mail address.',
        submitResponseIsVisible: true
      });
      return;
    }

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'newsletter', email: this.state.email })
    })
      .then(() => {
        this.setState({
          submitted: true,
          submitResponse: 'Thanks for signing up! We’ll be in touch.',
          submitResponseIsVisible: true
        });
        window.ga('send', {
          hitType: 'event',
          eventCategory: 'Newsletter',
          eventAction: 'Sign Up',
          eventLabel: this.props.home ? 'Home' : 'Footer'
        });
      })
      .catch(error => {
        this.setState({
          submitResponse: 'Oops... Something went wrong.',
          submitResponseIsVisible: true
        });
      });
  };

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  resetSubmitMessage() {
    this.setState({
      submitResponseIsVisible: false
    });
  }

  render() {
    return (
      <div className="newsletter">
        <h1 className="newsletter__title">
          Sign up for our newsletter<span>!</span>
        </h1>
        <div className="newsletter__cta">
          Stay up to date with the latest news from The Farm Project.
          <br/>
          <span className="newsletter__privacy">(Your data is safe. We’d never share it with any third parties.)</span>
        </div>

        <form
          name="newsletter"
          data-netlify="true"
          onSubmit={this.handleSubmit}
          className={`newsletter__form ${
            this.state.submitted ? 'newsletter__form__submitted' : ''
          }`}
        >
          <input type="hidden" name="form-name" value="newsletter" />
          <input
            type="email"
            className="newsletter__field"
            placeholder="Email address"
            name="email"
            onChange={this.handleChange}
            onFocus={this.resetSubmitMessage}
          />
          <input type="submit" className="newsletter__button" value="Join Us" />
        </form>

        <NewsletterSubmitMessage
          submitted={this.state.submitted}
          message={this.state.submitResponse}
          isVisible={this.state.submitResponseIsVisible}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/newsletter.js